import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["onPreviousClick", "onNextClick", "previousMonth", "nextMonth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from "react";
import { UI } from "../UI.js";
import { useDayPicker } from "../useDayPicker.js";
/**
 * Render the navigation toolbar with buttons to navigate between months.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Nav(props) {
  const {
      onPreviousClick,
      onNextClick,
      previousMonth,
      nextMonth
    } = props,
    navProps = _objectWithoutProperties(props, _excluded);
  const {
    components,
    classNames,
    labels: {
      labelPrevious,
      labelNext
    }
  } = useDayPicker();
  const handleNextClick = useCallback(e => {
    if (nextMonth) {
      onNextClick === null || onNextClick === void 0 || onNextClick(e);
    }
  }, [nextMonth, onNextClick]);
  const handlePreviousClick = useCallback(e => {
    if (previousMonth) {
      onPreviousClick === null || onPreviousClick === void 0 || onPreviousClick(e);
    }
  }, [previousMonth, onPreviousClick]);
  return React.createElement("nav", _objectSpread({}, navProps), React.createElement(components.PreviousMonthButton, {
    type: "button",
    className: classNames[UI.PreviousMonthButton],
    tabIndex: previousMonth ? undefined : -1,
    "aria-disabled": previousMonth ? undefined : true,
    "aria-label": labelPrevious(previousMonth),
    onClick: handlePreviousClick
  }, React.createElement(components.Chevron, {
    disabled: previousMonth ? undefined : true,
    className: classNames[UI.Chevron],
    orientation: "left"
  })), React.createElement(components.NextMonthButton, {
    type: "button",
    className: classNames[UI.NextMonthButton],
    tabIndex: nextMonth ? undefined : -1,
    "aria-disabled": nextMonth ? undefined : true,
    "aria-label": labelNext(nextMonth),
    onClick: handleNextClick
  }, React.createElement(components.Chevron, {
    disabled: nextMonth ? undefined : true,
    orientation: "right",
    className: classNames[UI.Chevron]
  })));
}